<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout
      justify-center
      wrap
      v-if="
        typeof $store.getters['user/userData'].role != 'undefined' &&
        ($store.getters['user/userData'].role.includes('Business') ||
          $store.getters['user/userData'].role.includes('GoodCause'))
      "
    >
      <h5>Resources:</h5>
      <template
        v-if="$store.getters['user/userData'].role.includes('Business')"
      >
        <a
          href="https://drive.google.com/open?id=1k9Q_SIXzjJy3ahQrQS-YjmuAFIuKpqsm"
          target="_blank"
          >UpstreamNZ Businesses Resources</a
        >
      </template>
      <template
        v-if="$store.getters['user/userData'].role.includes('GoodCause')"
      >
        <a
          href="https://drive.google.com/open?id=1_89BKaQd1x2fDjA0RBUBf2ljkCRuMW30"
          target="_blank"
          >UpstreamNZ Good Cause Resources</a
        >
      </template>
    </v-layout>
    <!-- Admin Section -->
    <v-layout
      v-if="
        typeof $store.getters['user/userData'].role != 'undefined' &&
        $store.getters['user/userData'].role.includes('Admin')
      "
      justify-center
      wrap
    >
      <v-flex sm6 xs12 md6>
        <material-card color="red" title="Contributions" offset="0">
          <v-layout key="form" wrap justify-center>
            <v-flex xs12>
              <v-text-field
                v-model="formData.contributions.current"
                hide-details
                label="Current Contributions"
                required
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="formData.contributions.goal"
                hide-details
                label="Goal Contributions"
                required
              />
            </v-flex>
            <v-flex xs7>
              <v-btn color="success" block @click="save">Save</v-btn>
            </v-flex>
          </v-layout>
        </material-card>
      </v-flex>
      <v-flex xs12 sm6>
        <material-card color="#4cc7e8" title="Supplier Introduction" offset="0">
          <v-form ref="supplierIntroForm">
            <v-layout key="form" wrap justify-center>
              <v-flex xs12 sm6>
                <v-autocomplete
                  v-model="formDataIntro.provisionSupplier"
                  :items="businesses"
                  item-text="name"
                  item-value="id"
                  label="Service Provision Supplier"
                  clearable
                  required
                  :rules="[
                    (v) => !!v || 'Service Provision Supplier is Required',
                  ]"
                />
              </v-flex>
              <v-flex xs12 sm6>
                <v-autocomplete
                  v-model="formDataIntro.clientSupplier"
                  :items="businesses"
                  item-text="name"
                  item-value="id"
                  label="Client Supplier"
                  clearable
                  required
                  :rules="[(v) => !!v || 'Client Supplier is Required']"
                />
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  label="Message"
                  counter="2000"
                  maxlength="2000"
                  required
                  :rules="[(v) => !!v || 'Message is Required']"
                  v-model="formDataIntro.message"
                >
                </v-textarea>
              </v-flex>
              <v-flex xs7>
                <v-btn
                  color="success"
                  :loading="sendIntroLoading"
                  block
                  @click="sendIntroduction"
                >
                  Send Introduction
                </v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      formData: {
        contributions: {
          current: null,
          goal: null,
        },
      },

      //Supplier Intro
      formDataIntro: {},
      sendIntroLoading: false,
    }),
    computed: {
      ...mapGetters({
        user: "user",
        businesses: "business/list",
        contributions: "general/contributions",
      }),
    },
    watch: {
      // whenever question changes, this function will run
      contributions: function (newContribution, oldcontributions) {
        this.formData.contributions.current = this.contributions.current;
        this.formData.contributions.goal = this.contributions.goal;
      },
    },
    mounted() {
      this.$store.dispatch("general/loadAll");
      this.formData.contributions.current = this.contributions.current;
      this.formData.contributions.goal = this.contributions.goal;
    },
    methods: {
      complete(index) {
        this.list[index] = !this.list[index];
      },
      save() {
        this.$store.dispatch("general/save", this.formData).then((business) => {
          this.saving = false;
        });
      },
      sendIntroduction() {
        if (this.$refs.supplierIntroForm.validate()) {
          this.sendIntroLoading = true;
          this.$store
            .dispatch("business/sendIntroduction", this.formDataIntro)
            .then(() => {
              this.$swal(
                "Success",
                "Introduction Emails have been sent",
                "success"
              );
              this.sendIntroLoading = false;
              this.formDataIntro = {};
            });
        }
      },
    },
  };
</script>
